import { getWeights } from "../src/scoring";

const validProps = {
  children: "object", // contains specifications derived from the current item
  score: "number", // indicates the importance of the item compared with its siblings
  label: "string", // the label to be displayed for this specification
  required: "boolean", // at least one option should be selected
  exclusive: "boolean", // at most one option can be selected
  mustSatisfy: "boolean", // a tool must satisfy the current item, and all of its children recursively, to be considered
};

function hasValidKeys(obj, isChildren = true) {
  if (Array.isArray(obj)) return false;

  if (typeof obj === "object")
    if (isChildren)
      return Object.keys(obj).reduce(
        (acc, cur) => acc && hasValidKeys(obj[cur], false),
        true
      );
    else
      return Object.keys(obj).reduce(
        (acc, cur) =>
          acc && cur in validProps && cur === "children"
            ? hasValidKeys(obj[cur], true)
            : typeof obj[cur] === validProps[cur] ||
            typeof obj[cur] === "undefined",
        true
      );
  else return false;
}

export const isValidTemplate = (template) => {
  if (!template) return false;
  if (Object.keys(template).length === 0) return false;
  if (!("ESS_tech" in template)) return false;
  return hasValidKeys(template);
};

const hasNull = (obj) =>
  Object.keys(obj).some(
    (key) => obj[key] === null || obj[key] === undefined || hasNull(obj[key])
  );

export const isValidInput = (input, template, ignoreRequired = false) => {
  const weights = getWeights(input, template, 100, false, ignoreRequired);
  return weights && !hasNull(weights);
};

export const isValidCapability = (capability, template) => {
  const weights = getWeights(capability, template, 100, true);
  return !hasNull(weights);
};
